import { authoritiesAndTheStateRoute } from './ClientBankIdentityHistoryOfUsage/AuthoritiesAndTheStatePage/route';
import { privateCompaniesRoute } from './ClientBankIdentityHistoryOfUsage/PrivateCompaniesPage/route';
import { clientBankIdentityRoute } from './route';

export const clientBankIdentityRoutes = clientBankIdentityRoute.addChildren([
	authoritiesAndTheStateRoute,
	privateCompaniesRoute,
]);
